/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {EmptyValue} from "../../../Components/Common/EmptyValue";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export function FulcrumIcon() {
	return (
        <span className="fa-layers fa-fw" style={{color: 'red'}}>
            <FontAwesomeIcon icon={['far', 'circle']} />
            <FontAwesomeIcon icon={['fas', 'caret-up']} transform="shrink-4 up-1" />
        </span>
	);
}

export function FulcrumRecordFieldViewer(props) {
	const {Value: value} = props;

	if ((value ?? '') === '') {
		return <EmptyValue/>;
	}

	return (
		<span style={{display: 'flex', alignItems: 'center', gap: '0.35em'}}>
			<span>{value}</span>
            <a href={`https://web.fulcrumapp.com/records/${value}`} target="_blank" rel="noopener noreferrer" style={{flexShrink: 0}}>
				<FulcrumIcon /> Fulcrum
			</a>
		</span>
	);
}
